// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #031A54, #1a237e);
  color: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
}

.hamburger {
  display: none;
  cursor: pointer;
}

.nav {
  display: flex;
  gap: 1rem;
}

.nav a {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.nav a:hover {
  background-color: rgba(255,255,255,0.1);
  text-decoration: none;
}

.auth {
  display: flex;
  align-items: center;
  gap: 1rem;
}

@media (max-width: 768px) {
  .hamburger {
    display: block;
  }

  .nav {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #031A54;
    flex-direction: column;
    display: none;
  }

  .nav.open {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #031A54, #1a237e);\n  color: white;\n  padding: 1rem 2rem;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.logo {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.hamburger {\n  display: none;\n  cursor: pointer;\n}\n\n.nav {\n  display: flex;\n  gap: 1rem;\n}\n\n.nav a {\n  color: white;\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.nav a:hover {\n  background-color: rgba(255,255,255,0.1);\n  text-decoration: none;\n}\n\n.auth {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n@media (max-width: 768px) {\n  .hamburger {\n    display: block;\n  }\n\n  .nav {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    background: #031A54;\n    flex-direction: column;\n    display: none;\n  }\n\n  .nav.open {\n    display: flex;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
